<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-users-cog"></i> Active Directory (AD)</h3>
      </div>
    </div>
    <Forms
      ref="frmAD"
      :title="'Configurações do Active Directory'"
      :showClearButton="false"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small v-show="form.servidor.required" class="text-danger">*</small> Servidor:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'meu.ldap.server.hostname ou IP'"
                          v-model="form.servidor.value"
                          :size="form.servidor.maxlength"
                          :required="form.servidor.required"
                          :state="form.servidor.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-4">
          <label><small v-show="form.porta.required" class="text-danger">*</small> Porta:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'389'"
                          v-model="form.porta.value"
                          :size="form.porta.maxlength"
                          :required="form.porta.required"
                          :state="form.porta.state"
                          autocomplete="false"></b-form-input>
          </div>
          <small class="text-muted">389 (LDAP) ou 636 (LDAPS)</small>
        </div>
        <div class="col-md-4">
          <label><small v-show="form.dn.required" class="text-danger">*</small> Base DN:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'DC=empresa,DC=local'"
                          v-model="form.dn.value"
                          :size="form.dn.maxlength"
                          :required="form.dn.required"
                          :state="form.dn.state"
                          autocomplete="false"></b-form-input>
          </div>
          <small class="text-muted">Base DN para busca de usuários</small>
        </div>
      </div>
      <!-- URL de Conexão removida - é gerada automaticamente pelos outros campos -->

      <!-- CAMPOS DE CONTA DE SERVIÇO -->
      <div class="form-group row pt-4">
        <div class="col-md-12">
          <h5><i class="fas fa-user-shield"></i> Conta de Serviço</h5>
          <small class="text-muted">Credenciais para conexão do NXCOOP com o Active Directory</small>
        </div>
      </div>

      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label><small v-show="form.serviceAccountDN.required" class="text-danger">*</small> DN da Conta de Serviço:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-user-cog"></i></span>
            <b-form-input type="text"
                          :placeholder="'CN=SVC_Nexum,OU=Service Accounts,OU=Empresa,DC=empresa,DC=local'"
                          v-model="form.serviceAccountDN.value"
                          :required="form.serviceAccountDN.required"
                          :state="form.serviceAccountDN.state"
                          autocomplete="false"></b-form-input>
          </div>
          <small class="text-muted">Distinguished Name completo da conta de serviço criada no AD</small>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-show="form.serviceAccountPassword.required" class="text-danger">*</small> Senha da Conta de Serviço:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-lock"></i></span>
            <b-form-input type="password"
                          :placeholder="'Senha da conta de serviço'"
                          v-model="form.serviceAccountPassword.value"
                          :required="form.serviceAccountPassword.required"
                          :state="form.serviceAccountPassword.state"
                          autocomplete="new-password"></b-form-input>
          </div>
          <small class="text-muted">Senha da conta de serviço (será armazenada de forma segura)</small>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-show="form.groupDN.required" class="text-danger">*</small> DN do Grupo de Usuários:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-users"></i></span>
            <b-form-input type="text"
                          :placeholder="'CN=API_Nexum,OU=Groups,OU=Empresa,DC=empresa,DC=local'"
                          v-model="form.groupDN.value"
                          :required="form.groupDN.required"
                          :state="form.groupDN.state"
                          autocomplete="false"></b-form-input>
          </div>
          <small class="text-muted">DN do grupo que contém os usuários autorizados a acessar o NXCOOP</small>
        </div>
      </div>

      <div class="form-group row pt-3">
        <div class="col-md-12">
          <b-button variant="success" @click="testConnection" :disabled="testingConnection">
            <i class="fas" :class="testingConnection ? 'fa-spinner fa-spin' : 'fa-plug'"></i>
            {{ testingConnection ? 'Testando...' : 'Testar Conexão' }}
          </b-button>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <div class="alert alert-info">
            <h6><i class="fas fa-info-circle"></i> Informações Importantes:</h6>
            <ul class="mb-0">
              <li><strong>CN</strong> = Common Name (Nome do objeto)</li>
              <li><strong>OU</strong> = Organizational Unit (Unidade Organizacional)</li>
              <li><strong>DC</strong> = Domain Component (Componente do domínio)</li>
              <li><strong>Base DN</strong> = Raiz onde serão buscados os usuários (ex: DC=empresa,DC=local)</li>
              <li><strong>Conta de Serviço</strong> = Usuário especial para o NXCOOP conectar no AD</li>
              <li><strong>Grupo de Usuários</strong> = Grupo que contém os usuários autorizados a acessar o NXCOOP</li>
              <li><strong>URL de Conexão</strong> = Gerada automaticamente (servidor:porta/base_dn)</li>
            </ul>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools.js'
import LdapRepository from '@/shared/http/repositories/configurations/ldap.js'

const ActiveDirectoryForms = {
  servidor: {
    value: '',
    required: true,
    state: null
  },
  porta: {
    value: '',
    required: true,
    state: null
  },
  dn: {
    value: '',
    required: true,
    state: null
  },
  caminho: {
    value: '',
    required: true,
    state: null
  },
  serviceAccountDN: {
    value: '',
    required: true,
    state: null
  },
  serviceAccountPassword: {
    value: '',
    required: true,
    state: null
  },
  groupDN: {
    value: '',
    required: true,
    state: null
  }
}

const ActiveDirectoryModel = {
  id: null,
  servidor: '',
  porta: 0,
  caminho: '',
  dn: '',
  serviceAccountDN: '',
  serviceAccountPassword: '',
  groupDN: '',
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}

export default {
  name: 'AD',
  mixins: [ActionsForm],
  data () {
    return {
      data: ActiveDirectoryModel,
      form: ActiveDirectoryForms,
      id: null,
      testingConnection: false
    }
  },
  watch: {
    // O campo 'caminho' deve ser igual ao Base DN (form.dn.value)
    'form.dn.value' (val) {
      if (val) {
        this.form.caminho.value = val
      }
    }
  },
  methods: {
    onLoad () {
      loading.push()
      LdapRepository.GetAll()
        .then((response) => {
          loading.close()
          var ldap = response.data.content
          if (ldap) {
            this.onEdit(ldap[0])
          }
        })
        .catch(this.onException)
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        this.data.id = obj.id
        this.data.status = 1
        this.form.servidor.value = obj.servidor
        this.form.porta.value = obj.porta
        this.form.dn.value = obj.dn
        this.form.serviceAccountDN.value = obj.serviceAccountDN || ''
        this.form.serviceAccountPassword.value = obj.serviceAccountPassword || ''
        this.form.groupDN.value = obj.groupDN || ''
        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.porta = this.form.porta.value
      LdapRepository.Create(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.porta = this.form.porta.value
      this.data.serviceAccountDN = this.form.serviceAccountDN.value
      this.data.serviceAccountPassword = this.form.serviceAccountPassword.value
      this.data.groupDN = this.form.groupDN.value
      LdapRepository.Update(this.data)
        .then((response) => {
          loading.close()
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    testConnection () {
      // Validar campos obrigatórios
      if (!this.form.servidor.value || !this.form.porta.value ||
          !this.form.serviceAccountDN.value || !this.form.serviceAccountPassword.value ||
          !this.form.groupDN.value) {
        toast.error('Preencha todos os campos obrigatórios antes de testar a conexão!')
        return
      }

      this.testingConnection = true

      const testData = {
        servidor: this.form.servidor.value,
        porta: this.form.porta.value,
        dn: this.form.dn.value,
        caminho: this.form.caminho.value,
        serviceAccountDN: this.form.serviceAccountDN.value,
        serviceAccountPassword: this.form.serviceAccountPassword.value,
        groupDN: this.form.groupDN.value
      }

      LdapRepository.TestConnection(testData)
        .then((response) => {
          this.testingConnection = false
          if (response.data.success) {
            toast.success('✅ Conexão com Active Directory estabelecida com sucesso!')
          } else {
            toast.error('❌ Falha na conexão: ' + (response.data.message || 'Erro desconhecido'))
          }
        })
        .catch((error) => {
          this.testingConnection = false
          let errorMsg = 'Erro ao testar conexão com AD'

          if (error.response && error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message
          } else if (error.message) {
            errorMsg = error.message
          }

          // Tratar erros específicos
          if (errorMsg.includes('USUARIO_NAO_AUTORIZADO')) {
            toast.error('🚫 Usuário não está no grupo autorizado para acessar o sistema')
          } else if (errorMsg.includes('Credenciais inválidas')) {
            toast.error('🔐 Credenciais inválidas no Active Directory')
          } else if (errorMsg.includes('Conta de serviço')) {
            toast.error('⚙️ Erro na configuração da conta de serviço')
          } else {
            toast.error('❌ ' + errorMsg)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/activedirectory/ad.vue